export enum ToolMapType {
  CurrentLocation,
  StreetView,
  ZoomByWindow,
  Fullscreen,
  Rotation,
  Identify,
  ShareLink,
  AvailableCoverage,
}
